<template>
  <div class="card">
    <div class="card-content">
      <h3 class="title is-4 is-size-3-desktop">
        <span class="icon is-left is-large">
          <i class="fas fa-dungeon"></i>
        </span>
        <span>{{ name }}</span>
      </h3>
      <p class="party-count is-6" v-html="partyCount"></p>
    </div>
    <footer v-if="isMyCampaign(creatorId)" class="card-footer">
      <router-link class="card-footer-item has-text-grey" :to="{ name: 'campaignDm', params: { id: campaignId, name: name, slug: slugify(name) }}">DM</router-link>
      <a href="#" class="card-footer-item has-text-danger" @click="deleteCampaign(campaignId)">Delete</a>
    </footer>
    <footer v-else class="card-footer">
      <router-link class="card-footer-item" :to="{ name: 'campaignPlayer', params: { id: campaignId, name: name, slug: slugify(name) }}">{{ enterText }}</router-link>
    </footer>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import { db } from '../main'

export default {
  name: 'CampaignCard',
  props: {
    campaignId: String, 
    name: String,
    creatorId: String
  },
  data () {
    return {
      members: [],
    }
  },
  firestore () {
    // return {
    //   members: db.collection('campaigns').doc(this.campaignId).collection('party')
    // }
    this.$bind('members', db.collection('campaigns').doc(this.campaignId).collection('party'))
    // console.log(this.id)
  },
  computed: {
    ...mapGetters(['user']),
    partyCount () {
      return (this.members.length) ? `this party has <strong>${this.members.length}</strong> adventurers so far...` : 'no adventurers have joined yet...'
    },
    hasJoined () {
      const users = this.members.map((member) => {
        return member.user
      })
      return (users.includes(this.user.uid)) ? true : false
    },
    enterText () {
      return (this.hasJoined) ? 'Enter' : 'Join'
    },
  },
  methods: {
    deleteCampaign (id) {
      db.collection('campaigns')
        .doc(id)
        .delete()
    },
    isMyCampaign (createdBy) {
      return (createdBy === this.user.uid) ? true : false
    },
  },
}
</script>
<style scoped>
.title {
  margin: 0;
}
.party-count {
  /* font-style: italic; */
  margin: 0.3625em 0 0;
}
.icon {
  color: #ccc;
}
.card-footer {
  margin-right: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/CampaignCard.vue